/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cargo_Apply_Price_To_Related_HelpInputs */

const en_cargo_apply_price_to_related_help = /** @type {(inputs: Cargo_Apply_Price_To_Related_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By default, editing price only updates this cargo.`)
};

const es_cargo_apply_price_to_related_help = /** @type {(inputs: Cargo_Apply_Price_To_Related_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por defecto, editar el precio solo actualiza esta carga.`)
};

/**
* | output |
* | --- |
* | "By default, editing price only updates this cargo." |
*
* @param {Cargo_Apply_Price_To_Related_HelpInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const cargo_apply_price_to_related_help = /** @type {((inputs?: Cargo_Apply_Price_To_Related_HelpInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cargo_Apply_Price_To_Related_HelpInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cargo_apply_price_to_related_help(inputs)
	return es_cargo_apply_price_to_related_help(inputs)
});